import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

// Lazy loading pages allows our build system to split up the code into different
// bundles, so customers do not have to download entire app at once. You can
// import these as normal if you do not need to split up code bundles between pages.
// Learn more https://reactjs.org/docs/code-splitting.html#route-based-code-splitting
const ReceivePage = React.lazy(() => {
  return Promise.resolve(require('./Receive'));
});

interface PagesProps {
  hideLayout?: boolean;
}

export default function Pages({ hideLayout = false }: PagesProps) {
  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <Switch>
        <Route exact path="/">
          <Redirect to="/receive" />
        </Route>
        <Route exact path={'/receive'} component={ReceivePage} />
        <Route path={'/receive/:receiveType/:referenceId?'} component={ReceivePage} />
        <Route component={ReceivePage} />
      </Switch>
    </React.Suspense>
  );
}
